import MovieEditor from './MovieEditor';

export default MovieEditor;
